import { Control, useWatch } from 'react-hook-form';
import { useTheme } from '@mui/material';

import { FormInput } from '@Components/Form';
import Flex from '@Components/Bases/Flex';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { IGoalsAndOperationalPlansFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';

type GoalDetailsFormProps = {
  goalsOperationalPlansFormControl: Control<
    IGoalsAndOperationalPlansFormValues,
    unknown
  >;
};

const GoalDetailsForm = ({
  goalsOperationalPlansFormControl,
}: GoalDetailsFormProps) => {
  const theme = useTheme();
  const completedSection = useWatch({
    control: goalsOperationalPlansFormControl,
    name: 'completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <Flex
      flexDirection={'column'}
      border={`1px solid ${theme.palette.grey[200]}`}
      borderRadius={1}
      gap={2}
      p={1}
    >
      <FormInput
        name="detailTh"
        label="เป้าหมาย (ไทย)"
        placeholder="กรุณาระบุเป้าหมาย (ไทย)"
        multiline
        minRows={3}
        required
        sx={isCompletedTh ? disabledFormInputStyles : undefined}
      />
      <FormInput
        name="detailEn"
        label="เป้าหมาย (อังกฤษ)"
        placeholder="กรุณาระบุเป้าหมาย (อังกฤษ)"
        multiline
        minRows={3}
        required
        sx={isCompletedEn ? disabledFormInputStyles : undefined}
      />
    </Flex>
  );
};

export default GoalDetailsForm;
